// AWS Amplify Configuration for Cognito Authentication
// Matches ecommerce-ui configuration

const awsExports = {
  Auth: {
    Cognito: {
      region: 'ap-southeast-1',
      userPoolId: 'ap-southeast-1_6lGSkBuM9',
      userPoolClientId: '4vu7nakb39bh6cvlov3khe52t1'
    },
  },
};

export default awsExports;
